/* eslint-disable no-mixed-spaces-and-tabs,no-param-reassign,no-tabs,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars,@typescript-eslint/no-use-before-define,no-var,vars-on-top */

import { EVENTS } from '../../../../../app/constants/events';
import { COMPONENT_TYPE } from '../../../../../app/constants/component_type';

xplenty.directive('salesforceObjectPicker', [
  '$rootScope',
  '$timeout',
  '$stateParams',
  'connectionsService',
  '$translate',
  'ConnectionItemsResource',
  function ($rootScope, $timeout, $stateParams, connectionsService, $translate, ConnectionItemsResource) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./salesforce-object-picker.html'),

      replace: true,

      controller: [
        '$scope',
        function ($scope) {
          $scope.objectNameOptions = [];

          let lastObjectName;

          $scope.loadObjects = function (withCacheRefresh) {
            if ($scope.component.connection.type && $scope.component.connection.id) {
              $scope.loadingObjects = true;

              const schemaRequestData = {
                force_fetch: withCacheRefresh,
              };

              if ($scope.componentFormStep) {
                $scope.componentFormStep.loading = true;
              }

              ConnectionItemsResource.objects(
                $scope.component.connection.type,
                $scope.component.connection.id,
                schemaRequestData,
              ).subscribe(
                function (objectEntities) {
                  if ($scope.componentFormStep) {
                    $scope.componentFormStep.loading = false;
                  }
                  if ($scope.component.object_name) {
                    lastObjectName = $scope.component.object_name;
                  }

                  $scope.objectNameOptions = objectEntities.entities.map((entity) => ({ text: entity, value: entity }));
                  $scope.loadingObjects = false;
                  if (lastObjectName) {
                    $scope.component.object_name = lastObjectName;
                    $scope.errorMessage = null;
                  } else if (lastObjectName) {
                    $scope.errorMessage = $translate.instant('salesforce-destination-editor.form.errors.object_name', {
                      objectName: lastObjectName,
                    });
                  } else {
                    $scope.errorMessage = null;
                  }
                  loadFields();
                },
                function (res) {
                  $scope.loadingObjects = false;
                  $scope.errorMessage = res.error.error_message;
                },
              );
            }
          };

          $scope.isFirstRun = true;

          $scope.$watch('component.connection.type', function () {
            $scope.loadObjects(false);
          });

          $scope.loadingObjects = false;
          $scope.errorMessage = null;

          const loadFields = function () {
            if (
              $scope.component.connection.type &&
              $scope.component.object_name &&
              $scope.component.object_name !== ''
            ) {
              const schemaRequestData = {
                object_name: $scope.component.object_name,
              };

              if ($scope.component.componentType === COMPONENT_TYPE.SALESFORCE_SOURCE_COMPONENT) {
                ConnectionItemsResource.fields(
                  $scope.component.connection.type,
                  $scope.component.connection.id,
                  schemaRequestData,
                ).subscribe(
                  (fieldsList) => {
                    const fields = [];
                    _.each(fieldsList.fields, function (field) {
                      fields.push({
                        name: field.name,
                        alias: field.name,
                        data_type: field.type,
                        length: field.length,
                        category: 'Schema',
                      });
                    });
                    $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_SET_AVAILABLE_FIELDS, fields);
                  },
                  (res) => {
                    $scope.errorMessage = res.error.error_message;
                  },
                );
              } else {
                ConnectionItemsResource.writableFields(
                  $scope.component.connection.type,
                  $scope.component.connection.id,
                  schemaRequestData,
                ).subscribe(
                  (fieldsList) => {
                    $rootScope.$broadcast(EVENTS.SALESFORCE_OBJECT_PICKER_FIELDS_LOADED, fieldsList.fields);
                  },
                  (res) => {
                    $scope.errorMessage = res.error.error_message;
                  },
                );
              }
            }
          };

          $scope.onObjectNameChange = (objectName) => {
            $scope.component.object_name = objectName;
            $scope.errorMessage = null;
            $rootScope.$broadcast(EVENTS.SALESFORCE_OBJECT_PICKER_FIELDS_LOAD_START);
            loadFields();
          };

          loadFields();

          $scope.$on(EVENTS.SCHEMA_IMPORTER_LOADING_STARTED, function () {
            loadFields();
          });
        },
      ],
    };
  },
]);
